import { useState } from "react";
import "./ResetPassword.css";
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate, Link } from 'react-router-dom';

export default function ResetPassword(){
  const location = useLocation();
  const { user } = useAuth();
  const params = new URLSearchParams(location.search);
  const token = params.get("token");

  

  const REACT_APP_API_URL = process.env.REACT_APP_API_BASE_URL_AUTH;

  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: ""
  })
  
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await fetch(`${REACT_APP_API_URL}/Auth/reset-password`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
         },
        body: JSON.stringify({
          email: user.email,
          token: token,
          newPassword: formData.newPassword
        }),
      });

      if (!response.ok) throw new Error("Failed send email address");

      alert("Email address sent successfully!");
    } catch (err) {
      console.error(err.message);
      alert("Error adding sending email address: " + err.message);
    }

     
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  return(
    <div className="reset-password-wrapper">
      <div className="reset-password-container">
        <form className="reset-password-form" onSubmit={handleSubmit}>
          <h2>Reset password</h2>
          <p>Enter a new password.</p>
          <div className="form-group">
            <input
              type="password"
              name="newPassword"
              placeholder=" "
              value={formData.newPassword}
              onChange={handleChange}
              required
            />
            <label htmlFor="password">New Password</label>
          </div>

          <div className="form-group">
            <input
              type="password"
              name="confirmPassword"
              placeholder=" "
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />
            <label htmlFor="password">Confirm Password</label>
          </div>

          {error && <p className="error">{error}</p>}

          <button type="submit">Reset password</button>
          <div className="back-to-login-link"><Link to="/login">Back to login</Link></div>
        </form>
      </div>
    </div>
  );
}